(function ($, _, angular, window) {
    'use strict';

    /**
     * NOTES:
     * - No value can be an empty string, it either has to be NULL or not included in the JSON output.
     * - Ensure the types are correct (e.g. string, integer)
     *
     *
     * $scope.model.payment.agreeDirectDebit is not being used as there is not a field to map it to in the JSON to be sent to ESB.
     * $scope.model.confirm.declareInfo is not being used as there is not a field to map it to in the JSON to be sent to ESB.
     */

    window.THF.Angular.JoinForm.service('submitApplication', ['MembershipModel', function (MembershipModel) {
        return function (scope, sendApplication) {
            if(scope.formState.display.loadingSubmission) {
                return;
            }
            
            sendApplication = sendApplication || false;

            var currentDate = moment().hour(0).minute(0).second(0).format('YYYY-MM-DD');
            var coverStartDate = moment(scope.model.cover.coverStartDate).hour(0).minute(0).second(0).format('YYYY-MM-DD');
            var joinDate = moment(scope.model.cover.coverStartDate).hour(0).minute(0).second(0).format('YYYY-MM-DD');

            // Ensure the cover start date is always in the future.
            if( moment(scope.model.cover.coverStartDate).hour(0).minute(0).second(0).isBefore(moment().hour(0).minute(0).second(0)) ) {
                coverStartDate = currentDate;
                joinDate = currentDate;
            }

            scope.applicationData = {
                "MembershipIdRangeCode": scope.apiSettings.membershipIdRangeCode, // "M1"
                "Membership": buildMembership(),
                "LeadSource": "Website",
                "LeadSourceDetail": "Full Join Us Form",
                "LeadMetadata": buildLeadMetaData()
            };

            if (sendApplication) {
                scope.formState.display.loadingSubmission = true;
                MembershipModel.submit(scope.model.contact.emailAddress, scope.applicationData, scope.formState.applicationId).then(
                    function(response) {
                        if( response.result ) {
                            if( response.content.transactionId ) {
                                scope.successState.transactionId = response.content.transactionId;
                            }
                            else if( response.content.membershipId ) {
                                scope.successState.memberId = response.content.membershipId;
                            }

                            // Track the quote using Facebook Tracking.
                            if(typeof fbq === 'function') {
                                fbq('track', 'CompleteRegistration');
                            }

                            DSTAPI.track('page', {
                                url: '/join-now-success'
                            });

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({ event: 'formSubmissionSuccess', formId: 'joinForm' });

                            var formInstance = document.querySelector('form[name="joinForm"]');
                            window.VWO = window.VWO || [];
                            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 1]);

                            if (scope.formState.turnOnAdalyserOnSubmit && typeof window.adalyserTracker !== 'undefined') {
                                window.adalyserTracker("trackEvent", "lce3", { value: scope.getQuotePrice('Yearly') }, true);
                            }

                            scope.showThankYou();
                        }
                        else {
                            var formInstance = document.querySelector('form[name="joinForm"]');
                            window.VWO = window.VWO || [];
                            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 0]);
                            scope.showErrorModal('Sorry about this', 'We\'re having trouble submitting this form right now. Do you want to save it and try again later? You can also join over the phone by calling us on '+scope.formState.sitePhone+'.', 'saveModal');
                        }
                        scope.formState.display.loadingSubmission = false;
                    },
                    function() {
                        scope.formState.display.loadingSubmission = false;
                        scope.showErrorModal('Sorry about this', 'We\'re having trouble submitting this form right now. Do you want to save it and try again later? You can also join over the phone by calling us on '+scope.formState.sitePhone+'.', 'saveModal');
                    }
                );
            }

            function getMedicareExpiryMonth() {
                var month = (moment('01/' + scope.model.personal.medicareExpiry, 'DD/MM/YYYY').month() + 1);
                return (month < 10) ? '0' + month : month;
            }

            function getMedicareExpiryYear() {
                return moment('01/' + scope.model.personal.medicareExpiry, 'DD/MM/YYYY').year();
            }

            function buildLeadMetaData() {

                var response = {};
                if(scope.model.cover.utm !== '') {
                    var asat = (new Date()).toISOString();
                    response.utm = 'asat=' + asat + '&' + scope.model.cover.utm;
                }

                if(scope.model.cover.ecid !== '') {
                    response.Ecid__c = scope.model.cover.ecid;
                }

                if(scope.model.cover.icid !== '') {
                    response.Icid__c = scope.model.cover.icid;
                }
                
                if(response.utm === '' && response.ecid === '' && response.icid === '') {
                    return null;
                }
                
                return response;
            }
            
            function buildMembership() {
                return {
                    "MembershipId": 1,
                    //"IsProspectiveMembership": true,
                    "HealthCover": buildHealthCover(),
                    "Contribution": buildContribution(),
                    "MembershipPersons": buildMembershipPersons(),
                    "Addresses": buildAddresses(),
                    "EmailAddresses": buildEmailAddresses(),
                    "PhoneNumbers": buildPhoneNumbers(),
                    "CommunicationPreferences": buildCommunicationPreferences(),
                    "CreditAccounts": buildCreditAccounts(),
                    "DebitAccounts": buildDebitAccounts(),
                    "CustomProperties": buildCustomProperties(),
                    "Group": buildGroup(),
                    "Agent": buildAgent(),
                    "Site": buildSite()
                };
            }

            function buildCreditAccounts() {
                var creditAccount = {
                    "AccountName": scope.model.payment.benefitsAccountName,
                    "AccountTypeCode": "Bank",
                    "IsActive": true,
                    "BankAccount": {
                        "BsbNumber": scope.model.payment.benefitsAccountBSB,
                        "AccountNumber": parseInt(scope.model.payment.benefitsAccountNumber, 10)
                    }
                };
                if (scope.model.payment.benefitsSameAsAbove == 'Y') {
                    creditAccount.AccountName = scope.model.payment.paymentAccountName;
                    creditAccount.BankAccount.BsbNumber = scope.model.payment.paymentAccountBSB;
                    creditAccount.BankAccount.AccountNumber = parseInt(scope.model.payment.paymentAccountNumber, 10);
                }

                return {
                    "CreditAccount": [
                        creditAccount
                    ]
                };
            }

            function buildDebitAccounts() {
                return {
                    "DebitAccount": [
                        {
                            "AccountName": scope.model.payment.paymentAccountName,
                            "AccountTypeCode": "Bank",
                            "IsActive": true,
                            "BankAccount": {
                                "BsbNumber": scope.model.payment.paymentAccountBSB,
                                "AccountNumber": parseInt(scope.model.payment.paymentAccountNumber, 10)
                            }
                            //,
                            //"ChargeCard": {
                            //    "ReferenceNumber": "string"
                            //}
                        }
                    ]
                };
            }

            function buildGroup() {
                return {
                    "GroupCode": scope.apiSettings.groupCode,
                    "EffectiveDate": coverStartDate
                    // "PayrollNumber": ""
                };
            }

            function buildAgent() {
                return {
                    "AgentCode": scope.apiSettings.agentCode
                    // "EffectiveDate": coverStartDate
                };
            }

            function buildSite() {
                return {
                    "LocationCode": scope.apiSettings.locationCode,
                    "SiteCode": scope.apiSettings.siteCode
                    // "EffectiveDate": coverStartDate
                };
            }

            function buildHealthCover() {
                var healthRateCode = '';

                if( scope.model.cover.emergencyAmbulance == 'Y' ) {
                    healthRateCode = THF.Utility.HealthRateCode.encode(
                        scope.model.cover.primaryState,
                        scope.model.cover.memberType,
                        '',
                        'Amb'
                    );
                }
                else {
                    var memberType = angular.copy( scope.model.cover.memberType );
                    if( scope.model.cover.nonStudentDependant == 'Y' ) {
                        memberType += 'X';
                    }

                    healthRateCode = THF.Utility.HealthRateCode.encode(
                        scope.model.cover.primaryState,
                        memberType,
                        scope.model.cover.hospitalCover,
                        scope.model.cover.extrasCover
                    );
                }
                return {
                    "RateCode": healthRateCode,
                    "EffectiveDate": coverStartDate,
                    "JoinDate": joinDate,
                    "CoverStatus": "Active"
                    //"CoverStatusReasonCode": healthRateCode
                };
            }

            function buildContribution() {

                var rebateTier = ( hasGovernmentRebate() ) ? parseInt(scope.model.cover.governmentRebateIncomeTier, 10) : null;
                var rebateTierEffectiveDate = coverStartDate;
                // BB: 2016-06-08: Temporary fix added for issues with the API (Requested by Client)
                if( currentDate <= '2016-07-01' && coverStartDate >= '2016-07-01' ) {
                    rebateTier = null;
                    rebateTierEffectiveDate = null;
                }


                // Check to see if the IsRebateDeclarationViewed
                var isRebateDeclarationViewed = false;
                if ( hasGovernmentRebate() && scope.model.confirm.declareRebateError !== 'true' ) {
                    if( scope.model.confirm.declareRebate == 'Y' ) {
                        isRebateDeclarationViewed = true;
                    }  
                }
                
                return {
                    //"DueDate": scope.model.payment.paymentInitialDeductionDate,
                    "DebitOnDate": scope.model.payment.paymentInitialDeductionDate,
                    //"PaidToDate": scope.model.payment.paymentInitialDeductionDate,
                    "Frequency": scope.model.payment.paymentFrequency,
                    "FrequencyEffectiveDate": scope.model.payment.paymentInitialDeductionDate,
                    "IsRebateDeclarationViewed": isRebateDeclarationViewed,
                    "RebateStatus": ( hasGovernmentRebate() ) ? 'Registered' : 'Unregistered',
                    "RebateStatusEffectiveDate": coverStartDate,
                    "RebateTier": rebateTier,
                    "RebateTierEffectiveDate": rebateTierEffectiveDate
                    // "RebatePercentage": 0,
                    //"RebateApplicant": {
                    //    "Person": buildMemberPerson(false)
                    //}
                };
            }

            function buildEmailAddresses() {
                return {
                    "EmailAddress": [
                        {
                            "EmailAddressType": "Personal",
                            "IsActive": true,
                            "IsConsentToEmail": (scope.model.confirm.communication == 'Y'),
                            "PreferredFormat": "Html",
                            "EmailAddress": scope.model.contact.emailAddress
                        }
                    ]
                };
            }

            function buildPhoneNumbers() {
                var mapping = {
                    'mobile': 'Mobile1',
                    'home': 'Home',
                    'office': 'Work1'
                };
                var phoneNumbers = [];
                var phoneNumber;
                if (scope.model.contact.phoneNumber.length > 0) {
                    for (var i = 0; i < scope.model.contact.phoneNumber.length; i++) {
                        phoneNumber = scope.model.contact.phoneNumber[i];
                        phoneNumbers.push({
                            "PhoneNumberType": mapping[phoneNumber.type],
                            "IsActive": true,
                            "PhoneNumber": phoneNumber.value
                        });
                    }
                }

                return {
                    "PhoneNumber": phoneNumbers
                };
            }

            var person = 0;

            function hasGovernmentRebate() {
                return ( scope.model.cover.governmentRebate == 'Y' );
            }

            function buildMembershipPersons() {
                var people = [];
                var member = {
                    "EffectiveDate": coverStartDate,
                    "JoinDate": joinDate,
                    "RelationshipCode": "Membr",
                    "IsRebateApplicant": hasGovernmentRebate(),
                    "LhcEntryAge": scope.getLHCAge(scope.model.cover.memberDOB, coverStartDate, (scope.model.personal.memberContinuousCover == 'Y')),
                    //"LhcIsEntryAgeExempt": true,
                    //"LhcIsOverride": true,
                    //"LhcAbsenceDays": 0,
                    "Person": buildMemberPerson(hasGovernmentRebate())
                };
                if( scope.model.personal.memberPreviousFundSwitching == 'Y' ) {
                    member.PreviousHealthFundCode =  scope.model.personal.memberPreviousFundName;
                    member.PreviousHealthFundRateCode =  "DFLT";
                    if( scope.model.personal.memberPreviousFundMemberNumber.trim() != '' ) {
                        member.PreviousHealthFundMembershipId =  scope.model.personal.memberPreviousFundMemberNumber;
                    }
                }
                people.push(member);


                // Add the Partner Details
                if (scope.model.cover.memberType == 'Cpl' || scope.model.cover.memberType == 'Fam') {
                    var partner = {
                        "EffectiveDate": coverStartDate,
                        "JoinDate": joinDate,
                        "LhcEntryAge": scope.getLHCAge(scope.model.cover.partnerDOB, coverStartDate, (scope.model.personal.partnerContinuousCover == 'Y')),
                        //"LhcIsEntryAgeExempt": true,
                        //"LhcIsOverride": true,
                        //"LhcAbsenceDays": 0,
                        "RelationshipCode": scope.model.personal.partner.partnerRelationship,
                        "IsRebateApplicant": false,
                        "Person": buildPartnerPerson()
                    };
                    if( scope.model.personal.partner.partnerPreviousFundSwitching == 'Y' ) {
                        partner.PreviousHealthFundCode =  scope.model.personal.partner.partnerPreviousFundName;
                        partner.PreviousHealthFundRateCode =  "DFLT";
                        if( scope.model.personal.partner.partnerPreviousFundMemberNumber.trim() != '' ) {
                            partner.PreviousHealthFundMembershipId =  scope.model.personal.partner.partnerPreviousFundMemberNumber;
                        }
                    }
                    if( scope.model.personal.previousFundAllSame == 'Y' ) {
                        partner.PreviousHealthFundCode =  scope.model.personal.memberPreviousFundName;
                        partner.PreviousHealthFundRateCode =  "DFLT";
                        if( scope.model.personal.memberPreviousFundMemberNumber.trim() != '' ) {
                            partner.PreviousHealthFundMembershipId =  scope.model.personal.memberPreviousFundMemberNumber;
                        }
                    }
                    people.push(partner);
                }

                // Add the dependants
                if (scope.model.cover.memberType == 'Fam' || scope.model.cover.memberType == 'SPFam') {
                    var item;
                    var tertiaryDependant;

                    if (scope.model.personal.dependants.length > 0) {
                        for (var i = 0; i < scope.model.personal.dependants.length; i++) {
                            item = scope.model.personal.dependants[i];

                            var dependant = {
                                "EffectiveDate": coverStartDate,
                                "JoinDate": joinDate,
                                "RelationshipCode": item.dependantRelationship,
                                "IsRebateApplicant": false,
                                "Person": buildDependantPerson(item)
                            };

                            var currentAge = THF.Utility.DateHelper.getAge(item.dependantDOB, scope.model.cover.coverStartDate);
                            if(currentAge >= joinFormPageData.dependantMinAge && currentAge <= joinFormPageData.dependantMaxAge && item.dependantTertiary !== 'Y') {
                                dependant.IsChildDependant = true;
                            }

                            if( item.dependantPreviousFundSwitching == 'Y' ) {
                                dependant.PreviousHealthFundCode =  item.dependantPreviousFundName;
                                dependant.PreviousHealthFundRateCode =  "DFLT";
                                if(typeof item.dependantPreviousFundMemberNumber === 'undefined') {
                                    item.dependantPreviousFundMemberNumber = '';
                                }

                                if(item.dependantPreviousFundMemberNumber === null) {
                                    item.dependantPreviousFundMemberNumber = '';
                                }

                                if( item.dependantPreviousFundMemberNumber.trim() != '' ) {
                                    dependant.PreviousHealthFundMembershipId =  item.dependantPreviousFundMemberNumber;
                                }
                            }

                            if( scope.model.personal.previousFundAllSame == 'Y' ) {
                                dependant.PreviousHealthFundCode =  scope.model.personal.memberPreviousFundName;
                                dependant.PreviousHealthFundRateCode =  "DFLT";
                                if( scope.model.personal.memberPreviousFundMemberNumber.trim() != '' ) {
                                    dependant.PreviousHealthFundMembershipId =  scope.model.personal.memberPreviousFundMemberNumber;
                                }
                            }

                            people.push(dependant);
                        }
                    }
                }

                return {
                    "MembershipPerson": people
                };
            }

            function buildMemberPerson(includeMedicare) {
                // isRebate = isRebate || false;
                var person = {
                    "TitleCode": scope.model.personal.memberTitle,
                    "GivenName": scope.model.personal.memberFirstName,
                    //"MiddleName": "",
                    "Surname": scope.model.personal.memberLastName,
                    "Gender": getGender(scope.model.personal.memberGender),
                    "BirthDate": scope.model.personal.memberDOB
                };
                if (includeMedicare) {
                    person.MedicareCardNumber = parseInt(scope.model.personal.medicareNumber, 10);
                    person.MedicareCardReferenceNumber = "1";
                    person.MedicareCardExpiryMonth = getMedicareExpiryMonth();
                    person.MedicareCardExpiryYear = getMedicareExpiryYear();
                    person.MedicareCardGivenName = scope.model.personal.medicareFirstName;
                    if( scope.model.personal.medicareInitial.trim() !== '' ) {
                        person.MedicareCardMiddleName = scope.model.personal.medicareInitial;
                    }
                    person.MedicareCardSurname = scope.model.personal.medicareLastName;
                }
                return person;
            }

            // "EmailAddresses": buildEmailAddresses()

            function buildPartnerPerson() {
                return {
                    "TitleCode": scope.model.personal.partner.partnerTitle,
                    "GivenName": scope.model.personal.partner.partnerFirstName,
                    //"MiddleName": "",
                    "Surname": scope.model.personal.partner.partnerLastName,
                    "Gender": getGender(scope.model.personal.partner.partnerGender),
                    "BirthDate": scope.model.personal.partner.partnerDOB
                };
            }

            function buildDependantPerson(dependant) {
                var isStudent = (dependant.dependantTertiary == 'Y');
                var person = {
                    // "TitleCode": "",
                    "GivenName": dependant.dependantFirstName,
                    //"MiddleName": "",
                    "Surname": dependant.dependantLastName,
                    "Gender": getGender(dependant.dependantGender),
                    "BirthDate": dependant.dependantDOB
                    // Only include if they are a student
                };
                if( isStudent ) {
                    if(typeof dependant.dependantTertiaryInstitute === 'undefined') {
                        dependant.dependantTertiaryInstitute = '';
                    }

                    if(dependant.dependantTertiaryInstitute === null) {
                        dependant.dependantTertiaryInstitute = '';
                    }
                    person.StudentYear = moment().year();
                    person.StudentInstitutionName = dataAlphaNumericSpacesOnly(dependant.dependantTertiaryInstitute);
                }

                return person;
            }


            function buildAddresses() {
                var addresses = [];

                // Home Address
                addresses.push({
                    "AddressType": "Home",
                    "EffectiveDate": coverStartDate,
                    "IsActive": true,
                    "Line1": scope.model.contact.homeAddress.AddressLine,
                    "Suburb": scope.model.contact.homeAddress.Locality,
                    "StateCode": scope.model.contact.homeAddress.State,
                    "Postcode": scope.model.contact.homeAddress.Postcode
                });

                if (scope.model.contact.postalAddressSameAsHome !== 'Y') {
                    addresses.push({
                        "AddressType": "Postal",
                        "EffectiveDate": coverStartDate,
                        "IsActive": true,
                        "Line1": scope.model.contact.postalAddress.AddressLine,
                        "Suburb": scope.model.contact.postalAddress.Locality,
                        "StateCode": scope.model.contact.postalAddress.State,
                        "Postcode": scope.model.contact.postalAddress.Postcode
                    });
                }

                return {
                    "Address": addresses
                };
            }

            function buildCommunicationPreferences() {
                var mapping = {
                    'sms': {
                        "CommunicationGroupId": 24,
                        "IsParticipating": true,
                        "CommunicationMediumId": 7
                    },
                    'mail': {
                        "CommunicationGroupId": 24,
                        "IsParticipating": true,
                        "CommunicationMediumId": 4
                    },
                    'email': {
                        "CommunicationGroupId": 24,
                        "IsParticipating": true,
                        "CommunicationMediumId": 6
                    }
                };

                return {
                    "CommunicationPreference": [
                        mapping[scope.model.contact.communicationPreference]
                    ]
                };
            }

            // Promo Code
            // $promotion_code = substr( preg_replace( '/[^0-9a-zA-Z]/', null, $data['promotion_code'] ), 0, 30 ); // max 30 chars alphanumeric

            // Custom properties
            // AUTHP - authorised partner
            // UN - union membership number
            // EligT - I consent to the Eligibility
            // HDYH - How did you hear
            // Promo - Promotional Code.
            // CCert - Authorised Contact by THF 'Yes' or 'No'
            // BDO - Business Development Officer Identification

            // How did you hear:
            // If the value is 'other' prefix with Other: add text here
            // Add the label instead of the value.

            function buildCustomProperties() {
                var customProperties = [];

                // console.log(scope.);
                if(scope.model.cover.memberType === 'Sgl' || scope.model.cover.memberType === 'SPFam') {
                    customProperties.push(buildCustomProperty('AUTHP', 'N/A'));
                }
                else {
                    customProperties.push(buildCustomProperty('AUTHP', (scope.model.personal.partner.partnerAuthorisation === 'Y') ? 'Yes' : 'No'));
                }

                if(scope.model.cover.bdo && scope.model.cover.bdo !== '') {
                    customProperties.push(buildCustomProperty('CHN', 'Website'));
                    customProperties.push(buildCustomProperty('OWN', 'joinus'));
                    customProperties.push(buildCustomProperty('SRC', scope.model.cover.bdo));
                    customProperties.push(buildCustomProperty('BDO', scope.model.cover.bdo));
                }

                if (scope.model.cover.contactCentre && scope.model.cover.contactCentre !== '') {
                    customProperties.push(buildCustomProperty('C CENTRE', scope.model.cover.contactCentre));
                }


                // Eligibility Consent
                if (scope.model.eligibility.readCriteria === 'Y') {
                    var eligibilityCode = scope.apiSettings.eligibilityCode;

                    var eligibilityValue = 'Other';
                    if( scope.model.eligibility.currentMember === 'Y') {
                        eligibilityValue = 'Current union';
                    }
                    else if( scope.model.eligibility.formerMember === 'Y') {
                        eligibilityValue = 'Former union';
                    }
                    else if( scope.model.eligibility.familyMember === 'Y') {
                        eligibilityValue = 'Family member';
                    }

                    customProperties.push(buildCustomProperty('Eligi', eligibilityValue));
                    customProperties.push(buildCustomProperty(eligibilityCode, 'I consent to the Eligibility'));

                }

                // Eligibility Union Membership Number
                if (scope.model.eligibility.union.trim() !== '') {
                    customProperties.push(buildCustomProperty('UN', scope.model.eligibility.union));
                }

                // How did you hear
                var option = _.find(scope.field.confirm.howDidYouHear.options, {value: scope.model.confirm.howDidYouHear});
                if (typeof option !== 'undefined') {
                    var text = '';
                    if (option.value === 'other') {
                        text = scope.model.confirm.howDidYouHearSpecify;
                        customProperties.push(buildCustomProperty('HDYH', text, 53));
                    }
                    else {
                        text = option.label;
                        customProperties.push(buildCustomProperty('HDYH', text));
                    }
                    
                }

                // Promo - Promotional Code.
                if (scope.model.confirm.promoCode.trim() !== '') {
                    customProperties.push(buildCustomProperty('Promo', scope.model.confirm.promoCode));
                }

                // Authorisation to contact previous health fund to be contacted by THF.
                customProperties.push(buildCustomProperty('CCert', (scope.model.personal.memberPreviousFundAuthorisation === 'Y') ? 'Yes' : 'No'));

                // Is receive marketing.
                customProperties.push(buildCustomProperty('IsRec', (scope.model.confirm.marketing === 'Y') ? 'Yes' : 'No'));

                // Adding UDP to track online tickets.
                // CP6 needs to be labeled as OFF.
                customProperties.push(buildCustomProperty('OFF', 'Online'));

                if(scope.model.confirm.referralMemberNumber !== '') {
                    customProperties.push(buildCustomProperty('Referring Member', scope.model.confirm.referralMemberNumber));
                }


                if( currentDate <= '2016-07-01' && coverStartDate >= '2016-07-01' ) {
                    var rebateTier = ( hasGovernmentRebate() ) ? parseInt(scope.model.cover.governmentRebateIncomeTier, 10) : null;
                    if( rebateTier !== null ) {
                        customProperties.push(buildCustomProperty('Tier', rebateTier));
                    }

                }
                
                // This will pass the explicit form selection directly into the application payload custom properties array, preventing Salescloud from falling back to an inferred "Yes".
                if (scope.model.personal.memberContinuousCover) {
                    var cchValue = (scope.model.personal.memberContinuousCover === 'Y') ? 'Yes' : 'No';
                    customProperties.push(buildCustomProperty('CCH', cchValue)); 
                }

                return {
                    "CustomProperty": customProperties
                };
            }

            function buildCustomProperty(key, value, charLimit) {
                charLimit = charLimit || 60;
                if( value !== null && value.toString ) {
                    value = value.toString();
                    value = dataRegexOnly(value, /[^0-9a-zA-Z :\/]/g);
                }
                value = dataMaxLength(value, charLimit);

                return {
                    "Key": key,
                    "Value": value
                };
            }

            function getGender(value) {
                return (value == 'M') ? 'Male' : 'Female'
            }

            /**
             * Data Sanitisation for HAMBS data only.
             *
             * @param value
             * @returns {*}
             */

            function dataRegexOnly(value, regex) {
                return value.replace(regex, '');
            }

            function dataAlphaNumericSpacesOnly(value) {
                return value.replace(/[^0-9a-zA-Z ]/g, '');
            }

            function dataAlphaNumericOnly(value) {
                return value.replace(/[^0-9a-zA-Z]/g, '');
            }

            function dataNumericOnly(value) {
                return value.replace(/[^0-9]/g, '');
            }

            function dataMaxLength(value, maxLength) {
                return value.substr(0, maxLength);
            }

        }
    }]);
})(jQuery, _, angular, window);
